import React from 'react';

export type KickerProps = React.HTMLAttributes<HTMLSpanElement>;

export const Kicker: React.FC<KickerProps> = ({ className = '', ...rest }) => (
  <span className={`kicker ${className}`} {...rest} />
);
